import {
    Container,
    CssBaseline,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IndividualExperiencePhotos from '../../../components/Experiences/IndividualExperiencePhotos';
import IndividualExperienceContent from '../../../components/Experiences/IndividualExperienceContent';
import IndividualExperienceHero from '../../../components/Experiences/IndividualExperienceHero';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    useGetIndividualAssetQuery,
    useGetIndividualOwnerQuery,
} from '../../../../app/Slices/SevenDayApiSlice';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import LoadingComponent from '../../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import UserRole from '../../../../shared/AuthRoles';
import { useEffect, useState } from 'react';
import React from 'react';
import { CustomSmallListChip } from '../../../../layout/styledcomponents/CustomChip';

export default function OwnersIndividualExperiencePage() {
    const theme = useTheme();
    const loggedInUser = UserRole();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');

    const navigate = useNavigate();
    const [hasClicked, setHasClicked] = useState(false);

    const onClickGoBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const urlRefType = window.location.href.split('/')[5];
    const urlRef = window.location.href.split('/')[6];

    const {
        data: getIndividualAsset,
        isFetching,
        error,
    } = useGetIndividualAssetQuery(
        `owners/${loggedInUser?.company}/modules/${urlRef}`,
    );

    useEffect(() => {
        if (loggedInUser?.role !== 'owner_admin') {
            navigate(`/viewExperiences/${urlRefType}/${urlRef}`);
        }
    }, [loggedInUser?.role]);

    const handleClick = () => {
        setHasClicked(true); // Mark the button as clicked
    };

    if (error) {
        navigate(`/*`);
    }

    return (
        <>
            <CssBaseline />
            <Grid
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'left',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        mt: '-130px',
                    },
                }}
            >
                {isFetching === true ? (
                    <Grid
                        sx={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            alignContent: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <LoadingComponent />
                    </Grid>
                ) : (
                    <Grid
                        // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        sx={(theme) => ({
                            maxWidth: '100%',
                            height: '100%',
                            backgroundColor: 'white.main',
                            justifyContent: isMobile ? 'center' : 'left',
                            alignItems: 'center',
                        })}
                    >
                        <Grid
                            sx={{
                                width: '100%',
                                display: { xs: 'none', md: 'flex' },
                            }}
                        >
                            <Typography
                                variant='h1'
                                sx={{ textDecoration: 'none' }}
                            >
                                {getIndividualAsset?.name}
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'dark.main',
                                    textAlign: isMobile ? 'center' : 'left',
                                    paddingLeft: '5px',
                                }}
                            >
                                <CustomSmallListChip
                                    size='small'
                                    style={{
                                        border: 0,
                                        backgroundColor:
                                            getIndividualAsset?.isAvailable
                                                ? theme.palette.green.main
                                                : 'red',
                                        color: 'white',
                                    }}
                                    label={
                                        getIndividualAsset?.isAvailable
                                            ? 'AVAILABLE'
                                            : 'UNAVAILABLE'
                                    }
                                    variant='filled'
                                />{' '}
                            </Typography>
                        </Grid>
                        <Grid
                            sx={{
                                textAlign: isMobile ? 'center' : 'left',
                                paddingBottom: isMobile ? '10px' : '0px',
                                display: { xs: 'none', md: 'flex' },
                            }}
                        >
                            <IndividualExperienceHero
                                experience={getIndividualAsset}
                            />
                        </Grid>{' '}
                        <Grid>
                            <Grid
                                sx={{
                                    position: 'relative',
                                    [theme.breakpoints.down('md')]: {
                                        top: '28px',
                                        mx: 'calc(50% - 50vw)',
                                    },
                                    zIndex: { xs: 10, md: 'auto' },
                                }}
                            >
                                <IndividualExperiencePhotos
                                    experience={getIndividualAsset}
                                />
                            </Grid>
                            <Grid
                                sx={{
                                    position: 'relative',
                                    [theme.breakpoints.down('md')]: {
                                        width: '100vw',
                                        mx: 'calc(50% - 50vw)',
                                        boxShadow: '0 -4px 8px rgba(0,0,0,0.1)',
                                        borderRadius: '16px 16px 0 0',
                                        zIndex: 12,
                                        backgroundColor: 'white.main',
                                    },
                                }}
                            >
                                <IndividualExperienceContent
                                    experience={getIndividualAsset}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            sx={{
                                width: '100%',
                                height: isMobile ? '80px' : '15%',
                                display: isMobile || isIpad ? 'none' : 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                paddingTop: '40px',
                                paddingBottom: isIpad ? '160px' : '90px',
                            }}
                        >
                            <CustomButton
                                onClick={onClickGoBack}
                                color='primary'
                                sx={{
                                    marginLeft: '-8px',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        color: 'primary.main',
                                        backgroundColor: 'transparent',
                                        background: 'none',
                                    },
                                }}
                            >
                                <ArrowBackIcon />{' '}
                                <Typography
                                    sx={{
                                        fontSize: '12px',
                                        paddingLeft: '5px',
                                    }}
                                >
                                    Back to experiences
                                </Typography>
                            </CustomButton>
                        </Grid>
                    </Grid>
                )}
                {/* Reserve Now button */}
                {isMobile && !hasClicked && (
                    <CustomButton
                        onClick={() => {
                            const calendarSection =
                                document.getElementById('calendarSection');
                            if (calendarSection) {
                                calendarSection.scrollIntoView({
                                    behavior: 'smooth',
                                });
                            }
                            handleClick();
                        }}
                        type='button'
                        variant='contained'
                        color='primary'
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            width: '100%',

                            padding: '15px',

                            borderRadius: 0,
                            zIndex: 1000,
                        }}
                    >
                        Reserve Now
                    </CustomButton>
                )}
            </Grid>
        </>
    );
}
